<template>
    <div>
        <div class="topbar topbar__dashboard">
            <div class="topbar__dashboard__inner">
                <div class="row align-items-baseline">
                    <div class="col-8 d-flex flex-wrap">

                        <div class="topbar__selectbox">
                            <select class="topbar__selectbox__item" v-model="days">
                                <option v-for="period in periods" :value="period.value" :key="period.value">{{ period.label }}</option>
                            </select>
                        </div>

                        <div class="topbar__selectbox">
                            <select class="topbar__selectbox__item" v-model="userType">
                                <option v-for="userType in userTypes" :value="userType.value" :key="userType.value">{{ userType.label }}</option>
                            </select>
                        </div>
                    </div>

                    <div v-if="false" class="col-4 d-flex justify-content-end">
                        <div class="topbar__selectbox topbar__selectbox__small">
                            <select class="topbar__selectbox__item">
                                <option>Customize</option>
                                <option>Customize</option>
                            </select>
                        </div>
                        <div class="topbar__selectbox topbar__selectbox__small">
                            <select class="topbar__selectbox__item">
                                <option>Export</option>
                                <option>Export</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <main class="main main--dark main--dashboard">

            <div class="content">
                <section class="dashboard dashboard--tasks">
                    <header class="dashboard__header">
                        <table class="header-table">
                            <tr>
                                <td>
                                    <h3 class="heading3">Tasks Assigned to
                                        <div class="tasks__select" v-click-outside="function() {openTasksTypeSelect = false}">
                                            <div @click="openTasksTypeSelect = true" class="tasks__select__chosen">
                                                <span :title="taskListTypes[tasksListType]">{{taskListTypes[tasksListType]}}</span>
                                            </div>
                                            <ul v-show="openTasksTypeSelect" class="multiselect__content">
                                                <li class="multiselect__element" v-for="(name, value) in taskListTypes"  :key="value" @click="tasksListType = value; openTasksTypeSelect = false">{{name}}</li>
                                            </ul>
                                        </div>
                                    </h3>
                                </td>
                                <td>
                                    <div class="dashboard--tasks__controls">
                                        <input class="form-search-primary" type="text" v-model="taskSearch" placeholder="Search tasks"/>
            
                                        <a @click="$refs.addTask.open(0)" class="dashboard--tasks__add ml-4">+ Add A Task</a>
                                        <div class="card m-0 py-0">
                                            <b-dropdown  class="drag-n-drop icons-list dropdown-simple " boundary="viewport">
                                                <b-dropdown-item class="icons-list__show" v-if="!tasksShowCompleted" @click="tasksShowCompleted = true">Show completed</b-dropdown-item>
                                                <b-dropdown-item class="icons-list__hide" v-if="tasksShowCompleted" @click="tasksShowCompleted = false">Hide completed</b-dropdown-item>
                                                <b-dropdown-item class="icons-list__csv" @click="exportTasks">Export CSV</b-dropdown-item>
                                            </b-dropdown>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </header>

                    <div class="dashboard__content">
                        <TasksList
                            ref="tasksList"
                            :list-type="tasksListType"
                            :search="taskSearch"
                            :show-completed="tasksShowCompleted"
                            v-on:loaded="tasksLoaded"
                        >
                        </TasksList>
                    </div>
                </section>

                <section class="dashboard dashboard--startups">
                    <header class="dashboard__header">
                        <h3 class="heading3">Startups</h3>
                        <a v-if="false" href="#" class="dashboard__actions"></a>
                    </header>

                    <div class="dashboard__content">
                        <ul class="dashboard__stats">
                            <li>
                                <div class="dashboard__stats__counter">
                                    <animated-number
                                        :value="addedStartupsCount"
                                        :duration="500"
                                        :round="true"
                                    />
                                </div>
                                <p>Startups added by {{ $store.state.user.company_name }} users</p>
                            </li>
                            <li>
                                <div class="dashboard__stats__counter">
                                    <animated-number
                                        :value="startupsWithActivityCount"
                                        :duration="500"
                                        :round="true"
                                    />
                                </div>
                                <p>Startups with activity</p>
                            </li>
                            <li>
                                <div class="dashboard__stats__counter">
                                    <animated-number
                                        :value="startupsAssociatedWithTrackersCount"
                                        :duration="500"
                                        :round="true"
                                    />
                                </div>
                                <p>associated with trackers</p>
                            </li>
                        </ul>

                        <div class="dashboard__content__inner">
                            <b-row>
                                <b-col sm="6">
                                    <h4 class="heading4">Most active startups</h4>
                                    <ul class="rows-list rows-list--secondary">
                                        <li v-for="startup in mostActiveStartups" :key="startup.id">
                                            <figure class="image-block image-block--xs">
                                                <img :src="LogoHelper.getLogo(startup.logo_url)" alt=""/>
                                            </figure>
                                            <div>
                                                <h5 class="heading5"><a :href="'/startups/' + startup.id" target="_blank">{{ startup.name }}</a></h5>
                                                <p>{{ startup.cnt }} interaction(s)</p>
                                            </div>
                                        </li>
                                    </ul>
                                </b-col>

                                <b-col sm="6">
                                    <h4 class="heading4">Stale startups <span class="hint">i</span></h4>
                                    <ul class="rows-list rows-list--secondary">
                                        <li v-for="startup in staleStartups" :key="startup.id">
                                            <figure class="image-block image-block--xs">
                                                <img :src="LogoHelper.getLogo(startup.logo_url)" alt=""/>
                                            </figure>
                                            <div>
                                                <h5 class="heading5"><a :href="'/startups/' + startup.id" target="_blank">{{ startup.name }}</a></h5>
                                                <p>No updates in {{ startup.stale_period }}</p>
                                            </div>
                                        </li>
                                    </ul>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </section>

                <section class="dashboard dashboard--searches">
                    <header class="dashboard__header">
                        <h3 class="heading3">Searches</h3>
                        <a v-if="false" href="#" class="dashboard__actions"></a>
                    </header>

                    <div class="dashboard__content">
                        <ul class="dashboard__stats">
                            <li>
                                <div class="dashboard__stats__counter">
                                    <animated-number
                                        :value="conductedSearchesCount"
                                        :duration="500"
                                        :round="true"
                                    />
                                </div>
                                <p>Searches conducted</p>
                            </li>

                            <li>
                                <div class="dashboard__stats__counter">
                                    <animated-number
                                        :value="savedSearchesCount"
                                        :duration="500"
                                        :round="true"
                                    />
                                </div>
                                <p>Searches saved</p>
                            </li>
                        </ul>

                        <div class="dashboard__content__inner">
                            <h4 class="heading4">Saved searches</h4>
                            <ul class="rows-list rows-list--secondary">
                                <li v-for="search in savedSearches" :key="search.id">
                                    <div>
                                        <h5 class="heading5"><a :href="'/startups?query='+search.id">{{ search.name }}</a></h5>
                                        <p>Created {{ search.created_at }} <template v-if="search.last_searched_at">Last searched {{ search.last_searched_at }}</template></p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </section>

                <section class="dashboard dashboard--trackers">
                    <header class="dashboard__header">
                        <h3 class="heading3">Trackers</h3>
                        <a v-if="false" href="#" class="dashboard__actions"></a>
                    </header>
                    <div class="dashboard__content">
                        <ul class="dashboard__stats">
                            <li>
                                <div class="dashboard__stats__counter">
                                    <animated-number
                                        :value="startupsCount.added"
                                        :duration="500"
                                        :round="true"
                                    />
                                </div>
                                <p>trackers added by {{ $store.state.user.company_name }} users for an all-time total of {{ startupsCount.all }}</p>
                            </li>
                            <li>
                                <div class="dashboard__stats__counter">
                                    <animated-number
                                        :value="trackersWithActivityCount"
                                        :duration="500"
                                        :round="true"
                                    />
                                </div>
                                <p>trackers with activity</p>
                            </li>
                            <li>
                                <div class="dashboard__stats__counter">
                                    <animated-number
                                        :value="trackersWithNoStartupsCount"
                                        :duration="500"
                                        :round="true"
                                    />
                                </div>
                                <p>trackers with no startups</p>
                            </li>
                        </ul>

                        <div class="dashboard__content__inner">
                            <b-row>
                                <b-col sm="6">
                                    <h4 class="heading4">Most active trackers</h4>
                                    <ul class="rows-list rows-list--secondary">
                                        <li v-for="tracker in mostActiveTrackers" :key="tracker.id">
                                            <div>
                                                <h5 class="heading5"><a :href="'/trackers/' + tracker.id" target="_blank">{{ tracker.name }}</a></h5>
                                                <p>{{ tracker.cnt }} update(s)</p>
                                            </div>
                                        </li>
                                    </ul>
                                </b-col>

                                <b-col sm="6">
                                    <h4 class="heading4">Stale trackers</h4>
                                    <ul class="rows-list rows-list--secondary">
                                        <li v-for="tracker in staleTrackers" :key="tracker.id">
                                            <div>
                                                <h5 class="heading5"><a :href="'/trackers/' + tracker.id" target="_blank">{{ tracker.name }}</a></h5>
                                                <p>No updates in {{ tracker.stale_period }}</p>
                                            </div>
                                        </li>
                                    </ul>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </section>

                <section class="dashboard dashboard--users">
                    <header class="dashboard__header">
                        <h3 class="heading3">Users</h3>
                        <a v-if="false" href="#" class="dashboard__actions"></a>
                    </header>

                    <div class="dashboard__content">
                        <ul class="dashboard__stats">
                            <li>
                                <div class="dashboard__stats__counter">
                                    <animated-number
                                        :value="usersCount.active"
                                        :duration="500"
                                        :round="true"
                                    />
                                </div>
                                <p>of {{ usersCount.all }} users logged in</p>
                            </li>
                            <li>
                                <div class="dashboard__stats__counter">{{ usersCount.editors }}</div>
                                <p>of {{ usersCount.all }} users added or edited content</p>
                            </li>
                        </ul>

                        <div class="dashboard__content__inner">
                            <b-row>
                                <b-col sm="6">
                                    <h4 class="heading4">Most active users</h4>
                                    <ul class="rows-list rows-list--secondary">
                                        <li v-for="user in mostActiveUsers" :key="user.id">
                                            <figure class="image-block image-block--rounded">
                                                <Avatar
                                                    :username="user.name"
                                                    :src="user.avatar"
                                                    :size="30">
                                                </Avatar>
                                            </figure>
                                            <div>
                                                <h5 class="heading5 heading5--secondary">{{ user.name}}</h5>
                                                <p>{{user.cnt}} edit(s)</p>
                                            </div>
                                        </li>
                                    </ul>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </section>

                <qrvey-end-user v-if="$store.state.user.company_type == 'enterprise' && $store.state.user.qrveyapp_id.length" settings="config"></qrvey-end-user>
            </div>

            <aside class="aside">
                <div class="aside__inner">
                    <div class="aside__inner__section">
                        <div class="image-block">
                            <img :src="LogoHelper.getLogo($store.state.user.company_logo)" alt="img"/>
                        </div>
                        <h4 class="heading4">{{ $store.state.user.company_name }}</h4>
                        <template v-if="$store.getters.isEnterprise">Enterprise</template>
                        <p><a :href="$store.state.user.company_url" target="_blank">{{$store.state.user.company_website}}</a></p>
                        <p v-if="$store.state.user.company_profile_text && $store.state.user.company_profile_text.length" v-html="$store.state.user.company_profile_text">

                        </p>

                        <!--            <p>Founded on 2012 | Enterprise <a href="#">switchpitch.com</a></p>-->
                        <!--            <p>Washington, District Of Columbia, 20007, United States, North America</p>-->
                        <!--            <p>SwitchPitch Profile Public URL: <a href="#">connect.switchpitch.com/companylinknamegoeshere/32324</a></p>-->
                    </div>

                    <div class="aside__inner__section">
                        <h4 class="heading4">Recently Viewed</h4>

                        <ul class="rows-list rows-list--secondary">
                            <li v-for="(startup, index) in lastVisitedStartups" :key="index">
                                <figure class="image-block image-block--xs">
                                    <img :src="LogoHelper.getLogo(startup.logo_url)" alt="img"/>
                                </figure>
                                <div>
                                    <h5 class="heading5"><a :href="'/startups/' + startup.id" target="_blank">{{ startup.name }}</a></h5>
                                    <p>Viewed
                                        <template v-if="startup.days > 0">{{ startup.days }} day(s) ago</template>
                                        <template v-else>today</template>
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </aside>
        </main>

        <add-task
            v-if="$store.state.canLoadGlobalComponents"
            ref="addTask"
            prefix="-dashboard"
        >
        </add-task>
    </div>
</template>

<script>
import dashboard from "@/services/dashboard.service"
import AnimatedNumber from "animated-number-vue"
import Avatar from 'vue-avatar'
import TasksList from '@/components/tasks/List'
import team from "@/services/team.service";
import user from "@/services/user.service";

export default {
    data() {
        return {
            days: 60,

            periods: [
                {
                    value: 60,
                    label: 'Last 60 days'
                },
                {
                    value: 30,
                    label: 'Last 30 days'
                },
            ],

            userType: 'all',

            userTypes: [
                {
                    value: 'all',
                    label: 'All users'
                },

                {
                    value: 'groups',
                    label: 'My groups'
                },
                {
                    value: 'my',
                    label: 'Only me'
                },
            ],

            taskSearch: "",

            tasksListType: '',
            tasksShowCompleted: false,
            groups: [],

            addedStartupsCount: 0,
            startupsWithActivityCount: 0,
            startupsAssociatedWithTrackersCount: 0,
            mostActiveStartups: [],
            staleStartups: [],
            lastVisitedStartups: [],

            conductedSearchesCount: 0,
            savedSearchesCount: 0,
            savedSearches: [],

            startupsCount: {
                added: 0,
                all: 0,
            },

            trackersWithActivityCount: 0,
            trackersWithNoStartupsCount: 0,

            mostActiveTrackers: [],
            staleTrackers: [],

            allUsersCount: 0,
            usersCount: {
                all: 0,
                active: 0,
                editors: 0,
            },

            mostActiveUsers: [],
            openTasksTypeSelect: false,
        }
    },

    components: {
        AnimatedNumber,
        Avatar,
        TasksList,
        AddTask: () => import("@/components/tasks/EditTask"),
    },

    watch: {
        days() {
            this.updateAll()
        },

        userType() {
            this.updateAll()
        },
    },

    computed: {
        taskListTypes() {
            let list = {}
            list['my'] = 'Me'
            if (this.$store.state.user.is_admin) {
                this.groups.forEach(item => {
                    list['group-' + item.id] = item.name
                })

                list['all'] = 'Everyone'
            }
            else {
                list['team'] = 'Teams'
            }

            return list
        }
    },

    mounted() {
        user.getTaskType(0, 0).then(response => {
            this.tasksListType = response.data
        })

        this.$store.watch(state => {

            if (this.$store.state.user.qrveyapp_id.length) {
                window.config.app_id = this.$store.state.user.qrveyapp_id
            }

            if (state.needUpdateStartups) {
                this.getStartups()
            }

            if (state.needUpdateTrackers) {
                this.getTrackers()
            }

            if (state.needUpdateUsers) {
                this.getUsers()
            }
        })

        if (this.$store.state.user.is_admin) {
            team.getGroupsList().then(response => {
                this.groups = response.data
            })
        }

        let taskId = this.$route.query.open_task
        if (taskId) {
            this.$refs.tasksList.editTask(taskId)
        }
    },

    methods: {
        updateAll() {

            this.getStartups()

            dashboard.getStartupsAssociatedWithTrackersCount(this.days, this.userType).then(response => {
                this.startupsAssociatedWithTrackersCount = response.data
            })

            dashboard.getMostActiveStartups(this.days, this.userType).then(response => {
                this.mostActiveStartups = response.data
            })

            dashboard.getStaleStartups(this.days, this.userType).then(response => {
                this.staleStartups = response.data
            })

            dashboard.getConductedSearchesCount(this.days, this.userType).then(response => {
                this.conductedSearchesCount = response.data
            })

            dashboard.getSavedSearchesCount(this.days, this.userType).then(response => {
                this.savedSearchesCount = response.data
            })

            dashboard.getSavedSearches(this.days, this.userType).then(response => {
                this.savedSearches = response.data
            })

            dashboard.getLastVisitedStartups().then(response => {
                this.lastVisitedStartups = response.data
            })

            this.getTrackers()
            this.getUsers()
        },

        getStartups() {
            dashboard.getAddedStartupsCount(this.days, this.userType).then(response => {
                this.addedStartupsCount = response.data
            })

            dashboard.getStartupsWithActivityCount(this.days, this.userType).then(response => {
                this.startupsWithActivityCount = response.data
            })
        },

        getUsers() {
            dashboard.getUsersCount(this.days, this.userType).then(response => {
                this.usersCount = response.data
            })

            dashboard.getMostActiveUses(this.days, this.userType).then(response => {
                this.mostActiveUsers = response.data
            })
        },

        getTrackers() {
            dashboard.getTrackersCount(this.days, this.userType).then(response => {
                this.startupsCount = response.data
            })

            dashboard.getTrackersWithActivityCount(this.days, this.userType).then(response => {
                this.trackersWithActivityCount = response.data
            })

            dashboard.getTrackersWithNoStartupsCount(this.days, this.userType).then(response => {
                this.trackersWithNoStartupsCount = response.data
            })

            dashboard.getMostActiveTrackers(this.days, this.userType).then(response => {
                this.mostActiveTrackers = response.data
            })

            dashboard.getStaleTrackers(this.days, this.userType).then(response => {
                this.staleTrackers = response.data
            })
        },

        exportTasks() {
            this.$refs.tasksList.exportCSV()
        },

        tasksLoaded() {
            this.updateAll()
            this.$store.commit('setCanLoadGlobalComponents', true)
        }
    }
}
</script>
